import { css } from '@/styled-system/css';

export const modalContentWrapperStyles = css.raw({
  position: 'relative',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const modalBodyStyles = css.raw({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  paddingInline: 0,
  paddingBlock: 0,
});
